if (!customElements.get("product-modal")) {
  customElements.define(
      "product-modal",
      class ProductModal extends ModalDialog {
          constructor() {
              super();
          }

          hide() {
              super.hide();
          }

          show(opener) {
              super.show(opener);
              this.showActiveMedia(opener);
          }

          showActiveMedia(e) {
              let mediaId = e.dataset.mediaId;
              let gallery = document.querySelector("media-gallery");
              let indexSlide = Number(gallery.querySelector(`button[data-media-id="${mediaId}"]`).dataset.mediaIndex);
              gallery.swiperSlideTo(indexSlide - 1);
              // playBtn && playBtn.click();
              // this.querySelectorAll(
              //   `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
              // ).forEach((element) => {
              //   element.classList.remove('active');
              // });
              // const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
              // debugger;
              // const activeMedia = gallery
              //     // .querySelector(`button[data-media-id="${mediaId}"]`)
              //     .querySelector(`deferred-media[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
              // console.log(activeMedia);
              // const activeMediaTemplate = activeMedia.querySelector("template");
              // const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
              // activeMedia.classList.add('active');
              // activeMedia.scrollIntoView();

              // const container = this.querySelector('[role="document"]');
              // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

              // if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent) {
              //     if (activeMediaContent.querySelector(".js-youtube")) {
              //         activeMedia.loadContent();
              //     } else {
              //         activeMediaContent.querySelector("video").play();
              //     }
              // }
          }
      }
  );
}